import {FRONTEND_DOMAINS} from "./DomainUrlConstants";

export const DESKTOP_REGISTRATION_LINKS = {
    [FRONTEND_DOMAINS.ABC]: "https://www.abc-airsea.com/spot2/abc#!administration.views.RegistrationInquiryCreateView",
    [FRONTEND_DOMAINS.CP]: "https://www.cargo-partner.com/spot2/cp#!administration.views.RegistrationInquiryCreateView",
    [FRONTEND_DOMAINS.VCP]: "https://www.spotworx.com/spot/vcp#!administration.views.RegistrationInquiryCreateView",
    [FRONTEND_DOMAINS.STAFF]: "https://www.cargo-partner.com/spot2/staff#!administration.views.RegistrationInquiryCreateView",

};

export const DESKTOP_LOGIN_LINKS = {
    [FRONTEND_DOMAINS.ABC]: "https://www.abc-airsea.com/spot2/abc",
    [FRONTEND_DOMAINS.CP]: "https://www.cargo-partner.com/spot2/cp",
    [FRONTEND_DOMAINS.VCP]: "https://www.spotworx.com/spot/vcp",
    [FRONTEND_DOMAINS.STAFF]: "https://www.cargo-partner.com/spot2/staff",
};

export const DESKTOP_TERMS_AND_CONDITIONS_LINKS = {
    [FRONTEND_DOMAINS.ABC]: "https://www.abc-airsea.com/spot2/abc#!core.TermsAndConditionsView",
    [FRONTEND_DOMAINS.CP]: "https://www.cargo-partner.com/spot2/cp#!core.TermsAndConditionsView",
    [FRONTEND_DOMAINS.VCP]: "https://www.spotworx.com/legal-notice/",
    [FRONTEND_DOMAINS.STAFF]: "https://www.cargo-partner.com/spot2/staff#!core.TermsAndConditionsView",
};

export const DESKTOP_IMPRINT_LINKS = {
    [FRONTEND_DOMAINS.ABC]: "https://abc-airsea.com/legal-statement/",
    [FRONTEND_DOMAINS.CP]: "https://www.cargo-partner.com/legal/legal-statement/",
    [FRONTEND_DOMAINS.VCP]: "https://spotworx.com/legal-notice/",
    [FRONTEND_DOMAINS.STAFF]: "https://www.cargo-partner.com/legal/legal-statement/",
};